import { useDispatch, useSelector } from "react-redux";

import { setProvisioningListCategoryCollapse } from "@/store/reducers/settings";
import Valkyrie, { viAngleDown } from "@sippy-platform/valkyrie";

import { Collapse, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function CollapsibleList({ id, name, count, children }) {
  const dispatch = useDispatch();

  const provisioningListCategoryCollapse = useSelector((state) => state.settings.provisioningListCategoryCollapse);

  function handleCollapse() {
    dispatch(
      setProvisioningListCategoryCollapse({
        ...provisioningListCategoryCollapse,
        [id]: !provisioningListCategoryCollapse?.[id],
      }),
    );
  }

  return (
    <List key={id} component="div">
      <ListItem disablePadding>
        <ListItemButton onClick={handleCollapse}>
          <ListItemText disableTypography primary={`${name} \u00b7 ${count}`} sx={{ fontWeight: 600 }} />
          <Valkyrie icon={viAngleDown} rotate={provisioningListCategoryCollapse?.[id] ? 0 : 180} />
        </ListItemButton>
      </ListItem>
      <Collapse in={!provisioningListCategoryCollapse?.[id]} unmountOnExit>
        <List component="nav">{children}</List>
      </Collapse>
    </List>
  );
}

CollapsibleList.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  count: PropTypes.number,
  children: PropTypes.node,
};

export default CollapsibleList;
